import { type FC } from 'react';
import {
  CouponInfo,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text
} from '@cencosud-cencommerce/paris-uikit';

import { BuyNowEventInteractiveTags } from '@/modules/shared/utils/gtmEvents/buyNowTypes';
import { sendEvent } from '@/modules/shared/utils/gtmEvents/sendEvents/sendBuyNowEvents';

interface ModalRemoveCouponProps {
  isOpen: boolean;
  onClose: () => void;
  removeCoupon: () => void;
}

const BACK_BUTTON_LABEL = 'Volver';
const DELETE_BUTTON_LABEL = 'Eliminar';
const DELETE_COUPON_MODAL_TEXT = 'Se eliminará el descuento aplicado';

const CardPaymentModal: FC<ModalRemoveCouponProps> = ({
  isOpen,
  onClose,
  removeCoupon
}) => {
  return (
    <Modal
      size="sm"
      isOpen={isOpen}
      onClose={onClose}
      className="tablet:!co-w-[432px] tablet:!co-h-[420px]"
    >
      <ModalHeader
        icon={{
          name: 'info-circle',
          fill: 'primary-500'
        }}
        className="[&_h3]:co-text-[0.875rem] tablet:[&_h3]:co-text-[1.25rem]"
        onClose={onClose}
        title="¿Quieres eliminar tu cupón?"
      />
      <ModalBody className="co-flex co-flex-col co-gap-4 co-px-2">
        <div className="co-flex co-flex-col co-gap-4">
          <Text variant="body2" weight={600}>
            {DELETE_COUPON_MODAL_TEXT}
          </Text>
          <CouponInfo
            iconName="il-coupon"
            discountLabel="Descuento:"
            discountAmount="$15.000"
            couponLabel="Cupón:"
            couponName="MiCupon"
            variant="neutral"
            className="!co-border-transparent [&]:co-border-transparent"
          />
        </div>
      </ModalBody>
      <ModalFooter
        buttonsAlign="horizontal"
        className="!co-flex !co-flex-row !co-w-full max-[1439px]:!co-justify-stretch max-[1439px]:!co-space-x-2 min-[1440px]:!co-justify-end min-[1440px]:!co-gap-2"
        primaryButton={{
          label: DELETE_BUTTON_LABEL,
          className:
            'co-bg-error-500 hover:co-bg-error-600 max-[1439px]:!co-flex-1 max-[1439px]:!co-w-full min-[1440px]:!co-flex-shrink-0 min-[1440px]:!co-w-auto',
          onClick: () => {
            sendEvent({
              event: 'baseEvent',
              extraFields: {
                'event-interactive-tag':
                  BuyNowEventInteractiveTags.RemoveCouponModalConfirmButton
              }
            });
            removeCoupon();
            onClose();
          }
        }}
        secondaryButton={{
          label: BACK_BUTTON_LABEL,
          className:
            'max-[1439px]:!co-flex-1 max-[1439px]:!co-w-full min-[1440px]:!co-flex-shrink-0 min-[1440px]:!co-w-auto',
          onClick: () => {
            sendEvent({
              event: 'baseEvent',
              extraFields: {
                'event-interactive-tag':
                  BuyNowEventInteractiveTags.RemoveCouponModalBackButton
              }
            });
            onClose();
          }
        }}
      ></ModalFooter>
    </Modal>
  );
};

export default CardPaymentModal;
